import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

import { AuthInfoIdValidate } from '@/api/pc-api/v1/auth/auth-info-id/validate';
import { BizTargetType } from '@/constants/bizTargetType';
import { BizType } from '@/constants/bizType';
import { Role } from '@/constants/role';

export type AuthState = {
  partnerId: string;
  partnerName: string;
  dealerId: string;
  dealerName: string;
  bizType: BizType | null;
  role: Role | null;
  bizTargetType: BizTargetType | null;
  targetId: number | null;
  targetType: string | null;
  authInfoId: string;
  newAuthInfoId: string;
  isAppRegNeeded: boolean;
};

type AuthAction = {
  setAuthInfo: (authInfo: AuthInfoIdValidate) => void;
  setAuthInfoId: (authInfoId: string) => void;
};

type AuthStore = AuthState & AuthAction;

const INIT_AUTH_STATE: AuthState = {
  bizTargetType: null,
  bizType: null,
  dealerId: '',
  dealerName: '',
  partnerId: '',
  partnerName: '',
  role: null,
  targetId: null,
  targetType: '',
  authInfoId: '',
  newAuthInfoId: '',
  isAppRegNeeded: false
};

export const useAuthStore = createWithEqualityFn<AuthStore>()(
  (set) => ({
    ...INIT_AUTH_STATE,
    setAuthInfo: ({
      bizTargetType,
      bizType,
      dealerId = '',
      dealerName = '',
      partnerId = '',
      partnerName = '',
      targetId,
      targetType = '',
      newAuthInfoId = '',
      needAppReg = false,
      role
    }) =>
      set({
        bizTargetType,
        bizType,
        dealerId,
        dealerName,
        targetId,
        targetType,
        newAuthInfoId,
        partnerId,
        partnerName,
        role,
        isAppRegNeeded: needAppReg
      }),
    setAuthInfoId: (authInfoId) => set({ authInfoId })
  }),
  shallow
);

export const getAuthStore = () => useAuthStore.getState();
